import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import PropTypes from 'prop-types';
import { Route, Routes } from 'react-router-dom';
import PermissionGroupListScreen from './screens/PermissionGroupListScreen';

PermissionGroup.propTypes = {
  role: PropTypes.string,
  subRole: PropTypes.string,
};

function PermissionGroup({ role, subRole }) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<PermissionGroupListScreen role={role} subRole={subRole} />} />
          {/* <Route
            path="staff"
            element={<PermissionGroupListScreen role={ChargeConstants.UserRole.ADMIN} />}
          />
          <Route
            path="sale"
            element={
              <PermissionGroupListScreen
                role={ChargeConstants.UserRole.AGENCY}
                subRole={AgencyConstants.AgencyRole.SALE}
              />
            }
          />
          <Route
            path="partner"
            element={
              <PermissionGroupListScreen
                role={ChargeConstants.UserRole.AGENCY}
                subRole={[
                  AgencyConstants.AgencyRole.INVESTOR,
                  AgencyConstants.AgencyRole.GROUP,
                ].join(',')}
              />
            }
          /> */}
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default PermissionGroup;
